import Card from "app/components/Card";
import React from "react";
import { useProjectsProgress } from "../hooks/useProjectsProgress";
import ProjectItem from "./ProjectItem";
import { ProjectsProgressWidgetSkeleton } from "./ProjectProgressSkeleton";

export default function ProjectsProgressWidget() {
  const { combinedProjects, isLoading } = useProjectsProgress();
  const shouldShowTwoRows = combinedProjects.length > 1;

  return (
    <Card
      className={`flex w-full flex-col gap-4 overflow-hidden rounded-md border border-gray-100 bg-white p-6 shadow-none ${
        shouldShowTwoRows ? "h-[248px]" : "h-[156px]"
      }`}
    >
      <span className="text-sm font-medium text-black">My projects</span>

      <div className="flex flex-1 flex-col gap-4 overflow-y-auto pr-2">
        {isLoading ? (
          <ProjectsProgressWidgetSkeleton />
        ) : combinedProjects.length === 0 ? (
          <div className="flex h-full w-full items-center justify-center">
            <span className="text-sm text-gray-500">No projects available</span>
          </div>
        ) : (
          combinedProjects.map((item, index) => (
            <ProjectItem key={index} item={item} index={index} />
          ))
        )}
      </div>
    </Card>
  );
}
